import dayjs from "dayjs"
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

export const FormatDateAsDisplay = (dateString: string): string => dayjs(dateString).format('LLL');